export default function ProfileIcon() {
    return  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M.5 10a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0z" stroke="#787878"/>
                <path d="M1.976 15.96a10.02 10.02 0 0 1 16.053-.005 9.99 9.99 0 0 1-16.053.005z" fill="#787878"/>
                <path d="M10 10.645a3.871 3.871 0 1 1 0-7.742 3.871 3.871 0 0 1 0 7.742z" fill="#787878"/>
            </svg>
}